import axios from "./axiosInstance";

export interface ResourceItem {
    resource_id: string;
    title_en?: string | null;
    title_ar?: string | null;
    thumbnail_url?: string | null;
    stakeholder_post_label?: string | null;
    sectors?: string | null;
}

// Fetch every report (one entry per resource_id) for the source picker.
const getResourcesList = async (): Promise<ResourceItem[]> => {
    try {
        const response = await axios.get(`resources/list`);
        return response.data?.resources ?? [];
    } catch (error) {
        console.error('Error fetching resources list:', error);
        throw error;
    }
}

export { getResourcesList };
